'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.deprecatedFlightStatusAdded = deprecatedFlightStatusAdded;
exports.deprecatedFlightStatusOverwritten = deprecatedFlightStatusOverwritten;
var DEPRECATED_FLIGHT_STATUS_ADDED = exports.DEPRECATED_FLIGHT_STATUS_ADDED = 'DEPRECATED_FLIGHT_STATUS_ADDED';

function deprecatedFlightStatusAdded(flightStatusHref) {
    return {
        type: DEPRECATED_FLIGHT_STATUS_ADDED,
        flightStatusHref: flightStatusHref
    };
}

var DEPRECATED_FLIGHT_STATUS_OVERWRITTEN = exports.DEPRECATED_FLIGHT_STATUS_OVERWRITTEN = 'DEPRECATED_FLIGHT_STATUS_OVERWRITTEN';

function deprecatedFlightStatusOverwritten(flightStatusHref) {
    return {
        type: DEPRECATED_FLIGHT_STATUS_OVERWRITTEN,
        flightStatusHref: flightStatusHref
    };
}


//////////////////
// WEBPACK FOOTER
// ./app/actions/deprecatedFlightStatusActions.js
// module id = 628
// module chunks = 0